module.exports = __webpack_public_path__ + "static/pic01-f9e6569b2460769dabb9ab4249f94a12.jpg";